export enum TestType {
  FOB = "fob",
  HPYLORI = "hpylori",
}

